"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlphaReceipts = getAlphaReceipts;
exports.getLockedTable = getLockedTable;
exports.getLockedTableFromReceipts = getLockedTableFromReceipts;
exports.getUnlocksData = getUnlocksData;
exports.getTableDataXtokens = getTableDataXtokens;
exports.mergeSameUserEntries = mergeSameUserEntries;
const tslib_1 = require("tslib");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const decimal_js_1 = require("decimal.js");
const fs_1 = tslib_1.__importDefault(require("fs"));
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const suiClient = (0, alphafi_sdk_1.getSuiClient)();
// use getReceipts()
async function getAlphaReceipts(alphaOwners) {
    const receipts = [];
    let index = 0;
    let stolenObjects = [];
    for (const owner of alphaOwners) {
        process.stdout.write(`Processing item ${index++} of ${alphaOwners.length}\r`);
        let ownedObjects = [];
        let cursor = null;
        let hasNextPage = true;
        while (hasNextPage) {
            const res = await suiClient.getOwnedObjects({
                owner: owner,
                cursor: cursor,
                filter: {
                    StructType: alphafi_sdk_1.poolInfo["ALPHA"].receiptType,
                },
                options: {
                    showContent: true,
                    showType: true,
                },
            });
            ownedObjects = ownedObjects.concat(res.data);
            cursor = res.nextCursor ? res.nextCursor : null;
            hasNextPage = res.hasNextPage;
        }
        if (ownedObjects.length > 1) {
            console.warn(`Multiple Alpha receipts for ${owner}`);
            stolenObjects = stolenObjects.concat(ownedObjects.filter((o) => {
                const receipt = o.data;
                return receipt.content.fields.owner !== owner;
            }));
            ownedObjects = ownedObjects.filter((o) => {
                const receipt = o.data;
                return receipt.content.fields.owner === owner;
            });
        }
        if (ownedObjects.length === 0) {
            console.log(`${owner} owns no receipts`);
        }
        else if (ownedObjects.length == 1) {
            receipts.push(ownedObjects[0].data);
        }
        else {
            console.log(`${owner} still has more than 1 receipts under his name, adding all`);
            ownedObjects.forEach((o) => receipts.push(o.data));
        }
        if (index === alphaOwners.length - 1) {
            process.stdout.write("\n");
        }
    }
    fs_1.default.writeFileSync("./alphaUnlocks/stolenReceipts.json", JSON.stringify(stolenObjects.map((o) => o.data)));
    return receipts;
}
async function getLockedTable(owner_receipt) {
    const nfts = owner_receipt.map(([, receipt]) => {
        return receipt;
    });
    let receiptData = [];
    for (let i = 0; i < nfts.length; i += 50) {
        const batch = nfts.slice(i, i + 50);
        const res = await (0, stsui_sdk_1.getMultiObjects)({
            ids: batch,
            options: { showContent: true },
        });
        const batchReceipts = res.map((obj) => {
            return obj.data;
        });
        receiptData = receiptData.concat(batchReceipts);
    }
    const owner_table = [];
    receiptData.forEach((receipt) => {
        const ownedBy = receipt.content.fields.owner;
        const lockedTable = receipt.content.fields.locked_balance?.fields.id.id;
        if (lockedTable)
            owner_table.push([ownedBy, lockedTable]);
    });
    return owner_table;
}
async function getLockedTableFromReceipts(receipts) {
    const owner_table = [];
    receipts.forEach((receipt) => {
        const ownedBy = receipt.content.fields.owner;
        const lockedTable = receipt.content.fields.locked_balance?.fields.id.id;
        if (lockedTable)
            owner_table.push([ownedBy, lockedTable]);
    });
    return owner_table;
}
async function getUnlocksData(owner_table) {
    let allUnlocksData = [];
    let index = 0;
    for (const entry of owner_table) {
        process.stdout.write(`Processing item ${index++} of ${owner_table.length}\r`);
        const [owner, table] = entry;
        const unlocksXtokens = await getTableDataXtokens(owner, table);
        if (unlocksXtokens) {
            const unlocks = unlocksXtokens?.map(([owner, xtokens, timestamp]) => {
                const tokens = new decimal_js_1.Decimal(xtokens).div(1e9).toString();
                return [owner, tokens, timestamp];
            });
            allUnlocksData = allUnlocksData.concat(unlocks);
        }
        if (index === owner_table.length - 1) {
            process.stdout.write("\n");
        }
    }
    return allUnlocksData;
}
//optimise
async function getTableDataXtokens(owner, table) {
    let locked_alpha_pos_arr = [];
    let currentCursor = null;
    do {
        const response = await suiClient.getDynamicFields({
            parentId: table,
            cursor: currentCursor,
        });
        locked_alpha_pos_arr = locked_alpha_pos_arr.concat(response.data);
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            break;
        }
    } while (true);
    if (locked_alpha_pos_arr.length > 0) {
        const promises = locked_alpha_pos_arr.map(async (locked_obj) => {
            const locked_item1 = await suiClient.getDynamicFieldObject({
                parentId: table,
                name: locked_obj.name,
            });
            if (locked_item1 && locked_item1.data) {
                const locked_item_object = locked_item1.data;
                const value = locked_item_object.content.fields.value.fields.value;
                return {
                    value: value,
                    timestamp: locked_item_object.content.fields.name,
                };
            }
            // If no data, return undefined or handle as needed
            return undefined;
        });
        const results = (await Promise.all(promises)).filter((result) => result !== undefined);
        const unlocks = results.map((o) => {
            if (o)
                return [owner, o?.value, o?.timestamp];
            else
                return [owner, "0", "0"];
        });
        return unlocks;
    }
}
function mergeSameUserEntries(allUnlocksData) {
    const map = {};
    allUnlocksData.forEach(([first, second, third]) => {
        const key = `${first}-${third}`;
        const value = parseFloat(second);
        if (map[key] !== undefined) {
            map[key] += value;
        }
        else {
            map[key] = value;
        }
    });
    const result = [];
    for (const key in map) {
        const [first, third] = key.split("-");
        result.push([first, map[key].toString(), third]);
    }
    return result;
}
tslib_1.__exportStar(require("./dbFunctions.js"), exports);
//# sourceMappingURL=index.js.map